module.exports = __webpack_public_path__ + "static/media/tif.fd881a7c.svg";